var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"v-btn--app text--secondary text-capitalize font-weight-regular px-2"},'v-btn',{
    text: true,
    ..._vm.$attrs,
  },false),_vm.$listeners),[(_vm.$slots.default)?_vm._t("default"):(_vm.path)?_c('i18n',{attrs:{"path":_vm.path}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }